export default __webpack_public_path__ + "static/media/image-main-2-w@3x.0f60d52b.png";